<header>
  <div class="header-page d-flex justify-items-between align-items-center">
    <div class="collapse-icon mobile-menu-container">
      @if (isMobile) {
         <img class="menu hamburger-menu" (click)="toggleSidebar('mobile')" src="{{ RESOURCE_SERVER_URL + '/assets/images/common_icons/Menu.svg' }}" alt="Menu" />
      } @else {
        @if (isMenuOpen) {
          <img class="menu" (click)="toggleSidebar('menu')" src="{{ RESOURCE_SERVER_URL + '/assets/images/common_icons/prev.svg' }}" alt="" />
        }
        @if (isMenuClose) {
          <img class="menu" (click)="toggleSidebar('close')" src="{{ RESOURCE_SERVER_URL + '/assets/images/common_icons/next.svg' }}" alt="" />
        }
      }
    </div>
    
    @if (isMobile) {
      <div class="mobile-logo-container" (click)="redirectHome($event)">
         <img class="bloom-size" src="{{ RESOURCE_SERVER_URL }}/assets/images/header/DXC_Logo_purple.svg" alt="Logo" />
      </div>
    }
    @if (isShowHeaderForSignUp()) {
      <div class="row align-items-center right-actions-container">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-right d-flex mobile-reset-col">
          <div class="col cell">
            @if (!isMobile) {
              <div class="home-icon">
                <ng-container>
                  <img src="{{ RESOURCE_SERVER_URL }}/assets/images/header/Home_2.svg" (click)="redirectHome($event)" />
                </ng-container>
              </div>
            }
            <!-- <div class="header-dropdown lob-class" *ngIf="optionsLOBs != null">
              <custom-select
                (valueChange)="onChangeLOB($event, lob)"
                [options]="optionsLOBs"
                size="small"
                [value]="lob.select"
                >
              </custom-select>
            </div> -->
            <!-- <div class="header-dropdown role-class" *ngIf="optionsRoles != null">
            <custom-select
              (valueChange)="onChangeRole($event, role)"
              [options]="optionsRoles"
              size="small"
              [value]="role.select"
              >
            </custom-select>
          </div> -->
            @if (optionsLanguages) {
              @if (PROFILE === ON_CUSTOMIDP) {
                <!-- Desktop: Original language selector -->
                <div class="language-selector-customidp desktop-language-selector">
                  <span class="language-label">{{ 'header.selectLanguage' | translate }}</span>
                  <div class="language-toggle" [class.expanded]="isLanguageDropdownOpen">
                    <!-- Collapsed state: show only active language -->
                    @if (!isLanguageDropdownOpen) {
                      <button
                        class="language-button active"
                        (click)="toggleLanguageDropdown()"
                      >
                        {{ getCurrentLanguageLabel() }}
                      </button>
                    }

                    <!-- Expanded state: show all languages horizontally -->
                    @if (isLanguageDropdownOpen) {
                      <div class="language-selector-wrapper">
                        <div class="language-buttons-container"
                             (wheel)="onLanguageContainerWheel($event)"
                             (mousedown)="onLanguageContainerMouseDown($event)"
                             (mousemove)="onLanguageContainerMouseMove($event)"
                             (mouseup)="onLanguageContainerMouseUp()"
                             (mouseleave)="onLanguageContainerMouseLeave()"
                             [class.dragging]="isDragging">
                          @for (language of getSortedLanguages(); track language.value) {
                            <button
                              class="language-button"
                              [class.active]="language.value === lang.select"
                              (click)="selectLanguage(language); $event.stopPropagation()"
                            >
                              {{ language.label }}
                            </button>
                          }
                        </div>
                        <button class="dismiss-button" (click)="closeLanguageDropdown(); $event.stopPropagation()">×</button>
                      </div>
                    }
                  </div>

                </div>

                <!-- Click outside to close - moved outside the main container -->
                @if (isLanguageDropdownOpen) {
                  <div class="language-overlay"
                       (click)="closeLanguageDropdown()"
                       (keydown.escape)="closeLanguageDropdown()"
                       tabindex="0"
                       aria-label="Close language selector">
                  </div>
                }

                <!-- Mobile: Language trigger button and bottom sheet -->
                <button class="mobile-language-trigger" (click)="openLanguageBottomSheet()">
                  {{ getCurrentLanguageCode() }}
                </button>
              } @else {
                <div class="header-dropdown dropdown-class desktop-language-dropdown">
                  <custom-select (valueChange)="onChangeLanguage($event)" [options]="optionsLanguages" size="small" [value]="lang.select"> </custom-select>
                </div>
                <!-- Mobile: Language trigger button -->
                <button class="mobile-language-trigger" (click)="openLanguageBottomSheet()">
                  {{ getCurrentLanguageCode() }}
                </button>
              }
            }
            <div class="dropstart ms-3">
              <div class="profileInfo">
                <!-- <b>{{getFullName()}} (ID-{{getUserId()}})</b> -->
              </div>
              <div class="dropdown-menu dropdown-menuRegion scrollable-menu dropdown-menu-left dropdown-menu-lg-right" aria-labelledby="dropdownMenuButton">
                @for (item of Profile; track item) {
                  <a (click)="onChangeMenu(item.value)" class="dropdown-item">
                    <span>{{ item.label }}</span>
                  </a>
                }
              </div>
              <button
                class="btn buttonRegion"
                type="button"
                id="dropdownMenuButton"
                data-display="static"
                data-toggle="dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img src="{{ RESOURCE_SERVER_URL }}/assets/images/header/Profile.svg" alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- Mobile Language Bottom Sheet -->
  @if (optionsLanguages && isMobile) {
    <div class="language-bottom-sheet-overlay" [class.open]="isLanguageBottomSheetOpen" (click)="closeLanguageBottomSheet()"></div>
    <div class="language-bottom-sheet" [class.open]="isLanguageBottomSheetOpen">
      <div class="bottom-sheet-handle"></div>
      <div class="bottom-sheet-header">
        <span class="bottom-sheet-title">{{ 'header.selectLanguage' | translate }}</span>
        <button class="bottom-sheet-close" (click)="closeLanguageBottomSheet()">×</button>
      </div>
      <div class="bottom-sheet-content">
        @for (language of optionsLanguages; track language.value) {
          <button
            class="language-option"
            [class.active]="language.value === lang.select"
            (click)="selectLanguage(language)"
          >
            {{ language.label }}
          </button>
        }
      </div>
    </div>
  }
</header>
